export default {
    billDate:'',
    dateTime:new Date(),
    manualDiscount:0,
    member:{},
    moneyMustPaid:999,
    payment:[], 
    pointDiscount:{ point:0, value:0 },
    pointToItem:[],
    posId:'',
    product:[
        // {
        //     name:'ขนมขายดี',
        //     qty:99,
        //     net:999,
        //     totalPrice:999,
        //     tempId:9
        // }
    ], 
    productDiscount:0,
    receiptNumber:1, 
    shopId:'',
    // staff:[],
    timestamp:new Date(), 
    totalQty:1, 
    net:999, 
    discount:0,
    campaign:[],
    coupon:[],
    change:0, // เงินทอน
    lucky:[],
    gainPoint:0,
    usedPoint:0,
    existPoint:0,
    vatAmount:0
}
